import {RecordForm} from '../forms/RecordForm';


import {useApplicationScreenshot} from '../hooks/useApplicationScreenshot.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";
import config from "../config";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = useApplicationScreenshot();

    return (
        <FormPageLayout
            title={`New ${config.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate(config.basePath)}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
